/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MatrixCareConflictErrorType = {
    PersonLockedError: 'person_locked_error',
    DuplicatePatientError: 'duplicate_patient_error',
    PartialMatchLockedError: 'partial_match_locked_error',
    MrnRequiredError: 'mrn_required_error',
} as const;
export type MatrixCareConflictErrorType = typeof MatrixCareConflictErrorType[keyof typeof MatrixCareConflictErrorType];


export function instanceOfMatrixCareConflictErrorType(value: any): boolean {
    for (const key in MatrixCareConflictErrorType) {
        if (Object.prototype.hasOwnProperty.call(MatrixCareConflictErrorType, key)) {
            if (MatrixCareConflictErrorType[key as keyof typeof MatrixCareConflictErrorType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MatrixCareConflictErrorTypeFromJSON(json: any): MatrixCareConflictErrorType {
    return MatrixCareConflictErrorTypeFromJSONTyped(json, false);
}

export function MatrixCareConflictErrorTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCareConflictErrorType {
    return json as MatrixCareConflictErrorType;
}

export function MatrixCareConflictErrorTypeToJSON(value?: MatrixCareConflictErrorType | null): any {
    return value as any;
}

export function MatrixCareConflictErrorTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): MatrixCareConflictErrorType {
    return value as MatrixCareConflictErrorType;
}

